import GridItensProcessoSolicitacao from "./Grid";

function ItensProcessoSection({
    idProcesso,
    etapaProcesso,
    setSolicitacaoProcessoItems
}) {

    const NomeForm = "Selecione os itens que fazem parte desta solicitação";

    return (
        <div className="row mt-4">
            <div className="col-12 col-md-12">
                <div className="block h-auto">
                    <div className="container-fluid">
                        <div className="row">

                            <div className="col-12 col-md-12 d-flex justify-content-between align-items-center">
                                <h2 className="mb-0">{NomeForm}</h2>

                                <button className="btn btn-menu d-flex align-items-end" type='button'>
                                    <i className="fa-solid fa-bars"></i>
                                </button>
                            </div>

                            <div className="row g-0">
                                <GridItensProcessoSolicitacao
                                    idProcesso={idProcesso}
                                    etapaProcesso={etapaProcesso}
                                    onSelectItensProcesso={setSolicitacaoProcessoItems}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ItensProcessoSection;